<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard"
                        :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid" :style="'calc(100vh - 1rem)' - dinamicBodySize">

            <Form ref="ABC" @submit="postUploadVideo">
                <div class="row">
                    <div class="col-6">
                        <div class="mt-1">
                            <InputUploadS3 ref="inputuploads3" @on-save="uploadFile"
                                           :labelText="'Anexo de Vídeo'" :isRequired="true"
                                           fileLimitText="Limite de arquivos até 800MB." />
                            <Field name="urlAnexo" label="Anexo" type="hidden" rules="required"
                                   v-model="uploadVideoCrud.urlAnexo" />
                            <ErrorMessage name="urlAnexo" class="form-error" v-show="showErrorMessage" />

                        </div>
                        <div class="mt-0">
                            <label class="form-label">Observação</label>

                            <ckeditor :editor="editor" v-model="uploadVideoCrud.dsObservacao">
                            </ckeditor>

                            <Field name="dsObservacao" label="Descrição" type="hidden" rules="required"
                                   v-model="uploadVideoCrud.dsObservacao" />
                            <ErrorMessage name="dsObservacao" class="form-error" v-show="showErrorMessage" />
                        </div>
                        <div>
                            <label class="form-label">Tempo em Minutos</label>
                            <Field name="nrTempo" label="Tempo" type="number" class="form-control shadow-v2"
                                   rules="required" v-model="uploadVideoCrud.nrTempo" />
                            <ErrorMessage name="nrTempo" class="form-error" v-show="showErrorMessage" />
                        </div>
                        <div class="mt-2">
                            <button type="submit" class="btn btn-red" style="width: 100%" form="form"
                                    @click="postUploadVideo">
                                <i class="fas fa-save pe-2"></i>
                                Concluir Upload
                            </button>
                        </div>
                    </div>

                    <div class="col-6 ps-0">

                        <InputSearch v-model="filtro_text" placeholder="Pesquise uma gravação" class="mt-1"
                                     @updateSearch="reloadGrid" />
                        <div class="mt-1 ms-3 me-3">
                            <DataTable :url_ajax="url_videoChamada()" :customHeightPaginate="sizeDatatableDinamicPG" :request_api="'comercial'"
                                       :customHeight="sizeDatatableDinamic" :ajax_set_result="setTable"
                                       @grid_refreshed="gridRefreshed" :refresh="refresh_grid" :filtros="filtro" method="GET"
                                       :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="true" :headers="headers"
                                       :pBtnsSlot="true" :is_modal="true" :is_NotLoading="NotLoading" styleBotton="bottom:-5px"
                                       sizeWidBooton="width:102.5%;left:1px" lineHeigthProp="padding-left: 0px !important;" borderBottom="padding-left: 0px !important;">
                                <template v-slot:BtnSlot="item">
                                    <button type="button" class="btn-red " @click="getDownload(item.row.idCortesiaAcesso)"
                                            v-if="item.row.urlAnexo != ''">
                                        <i class="fas fa-cloud-download-alt" aria-hidden="true"></i>
                                        <span class="btn-span-text baixar-anexo">Baixar</span>
                                    </button>
                                </template>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import $ from 'jquery';

    import DataTable from './../../../../components/App/Datatable.vue'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import InputSearch from '@/components/App/Input_Search.vue'
    import InputUploadS3 from '@/components/App/Input_Upload_s3.vue'
    // import AWS from 'aws-sdk';

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        name: 'Agendamento',
        components: {
            DataTable,
            InputUploadS3,
            OcorrenciaInfo,
            InputSearch,
            ckeditor: CKEditor.component
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                editor: ClassicEditor,
                refresh_grid: false,
                filtro: [
                    { active: true },
                ],
                headers: [
                    { class: 'col', name: 'dsLoginInclusao', text: 'Consultor', order: 0 },
                    { class: 'col', name: 'dsObservacao', text: 'Observações', order: 0 },
                    { class: 'col-2', name: 'dtInclusao', text: 'Data', order: 0 },
                    { class: 'col-2', name: 'nrTempo', text: 'Tempo', order: 0 },
                    { class: 'col-2', name: 'btns', text: '', actions: true, }

                ],
                filtroBusca: '',
                filtro_text: '',
                NotLoading: false,
                showErrorMessage: false,
                dinamicBodySize: '',
                sizeDatatableDinamic: '',
                sizeDatatableDinamicPG: '',

                urlAnotacaoAnexoUpload: process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesiaAcesso/PostUploadAnexo',

                uploadVideoCrud: {
                    dsObservacao: '',
                    nrTempo: 0,
                    idOcorrencia: 0,
                    urlAnexo: ''
                },
                ocorrencia: {},
                loading_upload: false
            }
        },

        methods: {
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                })
            },
            getDownload(value) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesiaAcesso/GetDownloadAnexo?idCortesiaAcesso=' + value, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    window.open(response.data.data, "_blank");
                })

            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = true;
            },
            updateSizeDinamic() {
                if (window.innerWidth <= 1400) {
                    this.dinamicBodySize = 'height: calc(100vh - 7rem);'
                    this.sizeDatatableDinamic = 'max-height: calc(100vh - 9rem);min-height: calc(100vh - 9rem);margin-top: 0px !important'
                    this.sizeDatatableDinamicPG = 'max-height: calc(100vh - 9.6rem);min-height: calc(100vh - 9.6rem);margin-top: 0px !important'


                } else if (window.innerWidth >= 3500) {
                    this.dinamicBodySize = 'height: calc(100vh - 17rem);'
                } else {
                    this.sizeDatatableDinamicPG = 'max-height: calc(100vh - 25rem);min-height: calc(100vh - 25rem);margin-top: 0px !important'
                    this.sizeDatatableDinamic = 'max-height: calc(100vh - 22.5rem);min-height: calc(100vh - 22.5rem);margin-top: 0px !important'
                    this.dinamicBodySize = 'height: calc(100vh - 17rem);'
                }
            },
            uploadFile(url) {
                this.uploadVideoCrud.urlAnexo = url;
            },
            url_videoChamada() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesiaAcesso/Get?idOcorrencia=' + $this.idOcorrencia;
            },
            setTable(result) {
                result.forEach((value, index) => {

                    if (value.nrTempo) {
                        value.nrTempo = `${value.nrTempo} Minutos`;
                    }

                })

                return result;

            },
            postUploadVideo() {
                let $this = this;

                $this.$refs.ABC.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            $this.uploadVideoCrud.idOcorrencia = $this.idOcorrencia;

                            if ($this.uploadVideoCrud.nrTempo <= 0) {
                                $this.$toast.show('alert', 'Tempo deve ser maior que 0', true);
                                return;
                            }

                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesiaAcesso/Post', $this.uploadVideoCrud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.zerarInformacoes();

                                    $this.reloadGrid();
                                    $this.$refs.inputuploads3.resetVariaveis();
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });

                            $this.showErrorMessage = false;

                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            zerarInformacoes() {
                this.uploadVideoCrud = {
                    dsObservacao: '',
                    nrTempo: 0,
                    idOcorrencia: 0,
                    urlAnexo: ''
                }

                var inputVideo = $('#file_video_chamada');
                inputVideo.val('');

                this.showErrorMessage = false;
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        mounted() {
            this.updateSizeDinamic();
            window.addEventListener('resize', this.updateSizeDinamic);
        },
        updated() {
            this.updateSizeDinamic();
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                if (newVal) {
                    this.getOcorrencia();

                }                
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;
                $this.filtroBusca = newVal;
            },
        },
    }

</script>

<style>

</style>